import React from 'react';
import { useRelatedPeople } from './useRelatedPeople.ts';
import { useBankAccounts } from './useBankAccounts.ts';
import { useTaxInformation } from './useTaxInformation.ts';
import { usePersonInvestmentProgrammes } from './usePersonInvestmentProgrammes.ts';
import { useEmploymentRecords } from './useEmploymentRecords.ts';

export type PersonDataController = ReturnType<typeof usePersonData>;
export const PersonDataContext = React.createContext<PersonDataController>(
	{} as PersonDataController
);

export const usePersonData = () => {
	const relatedPeople = useRelatedPeople();
	const bankAccounts = useBankAccounts();
	const taxInformation = useTaxInformation();
	const investmentProgrammes = usePersonInvestmentProgrammes();
	const employmentRecords = useEmploymentRecords();

	return {
		...relatedPeople,
		...bankAccounts,
		...taxInformation,
		...investmentProgrammes,
		...employmentRecords,
	};
};
